export default __webpack_public_path__ + "static/media/people5.fedecb17.svg";